(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zeiss_test"] && !Shopify.designMode) return;
  try {
    
  
  // will return e.g. 'en' or 'de'
 // var lang = document.getElementsByTagName('html')[0].lang;
  
  var lang = window.langify.locale.iso_code;
  var sizeElement = document.getElementById('ovs-zeiss-fullscreen');
  sizeElement.locale = lang;

  if(lang == 'sv'){
     document.getElementById('ovs-zeiss-fullscreen').setAttribute('result-button-text','Vår rekommendation');
  }
    if(lang == 'en'){
     document.getElementById('ovs-zeiss-fullscreen').setAttribute('result-button-text','Our recommendation');
  }

// if(lang == 'sv')
// {sizeElement.result-button-text = 'LÄS VÅR REKOMMENDATION';}

// if(lang == 'en')
// {sizeElement.result-button-text = 'READ OUR RECOMMENDATION';}

  
  
  document.getElementById('ovs-zeiss-fullscreen').addEventListener('route-back', (screen) => {
    window.location.href = backUrl;
  });
 
  document.getElementById('ovs-zeiss-fullscreen').addEventListener('result-screen-btn-clicked', () => {
    
    //alert('The user clicked the call-to-action on the result screen! Yay! :)');
      window.location.href = "https://bagarglas.se/pages/syntest-resultat";

    });

  } catch(e) { console.error(e); }
})();
})();
